import React from "react";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import actions from "../../redux/actions";
import styled from "styled-components";
import { IoCloseSharp } from "react-icons/io5";

const ModalControl = styled(Modal)`
  
  .ant-modal-content {
    border-radius: 10px;
    margin-left: auto;
    margin-right: auto;
    padding: 5px 0px 0px 0px;

    @media only screen and (min-width : 1200px) {
      width: 40%;
    }

    @media only screen and (max-width:768px){
      width: 75%;
    }
    @media only screen and (max-width : 450px){
      width: 95%;
    }
  }
  .ant-modal-header {
    border: none;
    text-align: center;
    span {
      
      @media only screen and (min-width : 1200px) {
        font-size: 2vw;
      }

      @media only screen and (max-width:768px){
        font-size: 26px;
      }
      @media only screen and (max-width : 450px){
        font-size: 24px
      }
    }
  }
  .ant-modal-body {
    padding-top: 0px;
  }

  .popup-icon-close {
    @media only screen and (min-width : 1200px){
      font-size: 2.5vw;
    }
    @media only screen and (max-width : 768px) {
      font-size: 22px;
    }

    @media only screen and (max-width : 450px) {
      font-size: 18px;
    }
  }

  .ant-modal-footer {
    display: none;
  }
`;

export default function ModalCustom(props) {
  const dispatch = useDispatch();

  const isVisibleSet = {
    1: useSelector((state) => state.popup.isVisible),
    2: useSelector((state) => state.popup.isVisible2),
  }

  const titleSet = {
    1: useSelector((state) => state.popup.title),
    2: useSelector((state) => state.popup.title2),
  }

  const contentSet = {
    1: useSelector((state) => state.popup.content),
    2: useSelector((state) => state.popup.content2),
  }

  const widthSet = {
    1: useSelector((state) => state.popup.width),
    2: useSelector((state) => state.popup.width2),
  }

  // no need [props.dataSet ? props.dataSet : 1] in prod
  let isVisible = isVisibleSet[props.set ? props.set : 1]; 
  let title = titleSet[props.set ? props.set : 1]
  let content = contentSet[props.set ? props.set : 1]
  let width = widthSet[props.set ? props.set : 1]

  const onClose = () => {
    switch (props.set) {
      case 1 : 
        return dispatch(actions.popup.toggleVisible(false))
      case 2 : 
        return dispatch(actions.popup.toggleVisible2(false))
      default:
        <div></div>;
    }
  };

  return (
    <ModalControl
      className={`popup-control data-${props.set}`}
      title={<span>{title}</span>}
      visible={isVisible}
      destroyOnClose={true}
      width={width}
      // style={{ top: 10% }}
      closeIcon={
        <IoCloseSharp className={"popup-icon-close"} onClick={onClose} />
      }
    >
      {content}
    </ModalControl>
  );
}
